export default __webpack_public_path__ + "static/media/waze-icon.8be38923.svg";